import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import axios from 'axios';
import toastr from 'toastr';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import * as Sentry from "@sentry/browser";
import { Integrations as TracingIntegrations } from "@sentry/tracing";

Vue.use(Router);

if (window.location.hostname === 'portal.tttc.ca' || window.location.hostname === 'dev-portal.tttc.ca') {
    Sentry.init({
        dsn: 'https://19e8ffd99b8349fe9067e9ee284905fd@o1109563.ingest.sentry.io/6148238',
        // debug: true,
        release: '1.1',
        sampleRate:0.2,
        tracesSampleRate:0.2,
        environment: process.env.ENVIRONMENT
    });

    if (localStorage.user_id) {
        Sentry.setUser({ username: localStorage.user_name });
    }
} 

function clearLocalStorage() {

    const preservedSettings = ['preferred_resolution','preferred_speed','preferred_video_volume','selectedCourseSets'];

    Object.keys(localStorage).forEach((key)=> {
        if (!preservedSettings.includes(key)) {
            localStorage.removeItem(key);
        }
    });

    if (!localStorage.getItem('selectedCourseSets') || localStorage.getItem('selectedCourseSets') === 'undefined') {
        localStorage.setItem('selectedCourseSets','{}');
    }

}

// ===================== Pages Components ======================
import Login from './components/Login';
import Home from './components/Home';
import Course from './components/Course';
import Settings from './components/Settings';
import Calendar from './components/Calendar';
import Discussion from './components/Discussion';
import Thread from './components/Thread';
import VideoPlayer from './components/VideoPlayer';
import Resources from './components/Resources';
import Assignments from './components/Assignments';
import Support from './components/Support';
import Inbox from './components/Inbox';
import HandIns from './components/HandIns';
import Forum from './components/widgets/Forum';
import PostsByUser from './components/PostsByUser';
import Help from './components/Help';
import HelpPage from './components/HelpPage';
import ResetPassword from './components/ResetPassword';
import SoftwareInstallation from './components/SoftwareInstallation';
import SoftwareKeys from './components/SoftwareKeys';
import Finance from './components/Finance';
import PathSelector from './components/PathSelector';
import Maintenance from './components/Maintenance';
import CampusDashboard from './components/CampusDashboard';
import GalleryListViewer from './components/GalleryListViewer';
import GalleryEditor from './components/GalleryEditor';
import GalleryViewer from './components/GalleryViewer';
import Invoices from './components/Invoices';
import KbHome from './components/KbHome';
import KbSearch from './components/KbSearch';
import KbCategory from './components/KbCategory';
import KbArticle from './components/KbArticle';
import KbArticleEditor from './components/KbArticleEditor';
import MentorSelector from './components/MentorSelector';
import MentorProfile from './components/MentorProfile';
import MentorConnections from './components/MentorConnections';
import MentorConnectionApproval from './components/MentorConnectionApproval';
import FinalProject from './components/FinalProject';
import AlumniPicker from './components/AlumniPicker';
import Status from './components/Status';
import Journey from './components/Journey';
import ForumHome from './components/ForumHome';
import ForumCategory from './components/ForumCategory';
import ForumThread from './components/ForumThread';
import NewForumThread from './components/NewForumThread';
import ForumSearch from './components/ForumSearch';
import ForumUser from './components/ForumUser';
import WeeklyUpdates from './components/WeeklyUpdates';
import SIN from './components/SIN';
import SoftwareRequests from './components/SoftwareRequests';
import ArtStation from './components/ArtStation';
import CampusSubmission from './components/CampusSubmission';
import Feedback from './components/Feedback';

// Instructor views
import Dashboard from './components/Dashboard';
import MentorDashboard from './components/MentorDashboard';
import MentorCheckins from './components/MentorCheckins';
import MentorProfileEditor from './components/MentorProfileEditor';
import CourseAdmin from './components/CourseAdmin';
import Student from './components/Student';
import Assignment from './components/Assignment';
import VideoAdmin from './components/VideoAdmin';
import IntroVideos from './components/IntroVideos';
import GroupStatistics from './components/GroupStatistics';
import GlobalMentorship from './components/GlobalMentorship';
import TAMeetings from './components/TAMeetings';

var maintenanceMode = false;
// ==================== Router registration ====================
//
const router = new Router({
    routes: [{
            path: '/',
            name: 'login',
            component: Login,
            beforeEnter: function(to, from, next) {
                if (localStorage.token) {
                    if (localStorage.roles.includes('CampusStudent') || localStorage.roles.includes('CampusInstructor')) {
                        if (localStorage.terms.toString().split(',').length === 4) {
                            next({ path: '/mentor-dashboard' });
                        } else {
                            next({ path: '/campus-dashboard' });
                        }
                    } else if (localStorage.roles.indexOf('Student') > -1) {
                        next({ path: '/home' });
                    } else if (localStorage.roles.indexOf('TA') > -1) {
                        next({ path: '/ta-sessions' });
                    } else if (localStorage.roles.includes('Recruiter')) {
                        next({ path: '/galleries' });
                    } else if (localStorage.roles.includes('CourseAdmin') || localStorage.roles.includes('LessonAuditor')) {
                        next({ path: '/dashboard' });
                    } else if (localStorage.roles.includes('Admin')) {
                        next({ path: '/forum' });
                    } else if (localStorage.roles.indexOf('Faculty') > -1 ||
                        localStorage.roles.indexOf('OnlineDirector') > -1 ||
                        localStorage.roles.indexOf('CampusDirector') > -1
                    ) {
                        next({ path: '/forum' });
                    } else if (localStorage.roles.indexOf('Mentor') > -1) {
                        if (localStorage.terms && localStorage.terms !== '' && localStorage.terms !== 'null') {
                            next({ path: '/mentor-dashboard' });
                        } else {
                            next({ path: '/mentor-selector' });
                        }
                    } else {
                        next({ path: '/dashboard' });
                    }
                } else {
                    next();
                }
            }
        },
        {
            name: 'home',
            path: '/home',
            component: Home,
        },
        {
            path: '/finance',
            name: 'finance',
            component: Finance
        },
        {
            path: '/status',
            name: 'status',
            component: Status
        },
        {
            path: '/path-selector',
            name: 'pathSelector',
            component: PathSelector,
            beforeEnter: function(to, from, next) {
                if (localStorage.path && localStorage.path == '9200') {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            path: '/alumni',
            name: 'alumni',
            component: AlumniPicker
        },
        {
            path: '/sin',
            name: 'sin',
            component: SIN
        },
        {
            path: '/artstation',
            name: 'artstation',
            component: ArtStation
        },
        {
            path: '/meetings',
            name: 'Meetings',
            component: GlobalMentorship,
            beforeEnter: function(to, from, next) {
                if (!localStorage.roles.includes('GlobalMentor') && !localStorage.roles.includes('Recruiter')) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            path: '/ta-sessions',
            name: 'TA Sessions',
            component: TAMeetings,
            beforeEnter: function(to, from, next) {
                if (!localStorage.roles.includes('TA')) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            path: '/mentor-selector',
            name: 'mentorSelector',
            component: MentorSelector
        },
        {
            path: '/mentor-connections',
            name: 'mentorConnections',
            component: MentorConnections
        },
        {
            path: '/mentor-profile/:id',
            name: 'mentorProfile',
            component: MentorProfile
        },
        {
            name: 'activate',
            path: '/activate',
            component: Login,
        },
        {
            name: 'home',
            path: '/home',
            component: Home,
        },
        {
            name: 'campus-dashboard',
            path: '/campus-dashboard/:courseId?/:instanceId?/:videoId?',
            component: CampusDashboard,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.includes('CampusStudent') ||
                    localStorage.roles.includes('CampusInstructor') ||
                    localStorage.hasLibraryAccess == "true" ||
                    localStorage.roles.includes('CampusMentor') ||
                    (localStorage.roles.includes('Mentor'))) {

                    next();
                } else {
                    next({ path: '/' });

                }
            }
        },
        {
            name: 'campus-submission',
            path: '/campus-submission',
            component: CampusSubmission,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.includes('CampusStudent') ||
                    localStorage.transitioned === "true") {
                    next();
                } else {
                    next({ path: '/' });

                }
            }
        },
        {
            name: 'dashboard',
            path: '/dashboard',
            component: Dashboard,
            beforeEnter: function(to, from, next) {
                if (!localStorage.roles.includes('Supervisor') &&
                    !localStorage.roles.includes('Mentor') &&
                    !localStorage.roles.includes('OnlineDirector') &&
                    !localStorage.roles.includes('CourseAdmin') &&
                    !localStorage.roles.includes('CampusDirector') &&
                    !localStorage.roles.includes('LessonAuditor')
                ) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'reelreview',
            path: '/reel-review',
            component: Dashboard,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.includes('OnlineReelReviewer')) {
                    next();
                } else {
                    next({ path: '/' });
                }
                
            }
        },
        {
            name: 'mentorConnectionApproval',
            path: '/mentor-connection-approval',
            component: MentorConnectionApproval,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('OnlineDirector') === -1 && localStorage.roles.indexOf('CourseAdmin') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'mentorCheckins',
            path: '/checkins',
            component: MentorCheckins,
            beforeEnter: function(to, from, next) {
                if (localStorage.terms.split(',').length === 4 || localStorage.transitioned == 'true' || localStorage.roles.includes('CampusStudent') || localStorage.roles.includes('Mentor')) {
                    next();
                } else {
                    next({ path: '/' });
                }
            }
        },
        {
            name: 'mentorDashboard',
            path: '/mentor-dashboard',
            component: MentorDashboard,
            // beforeEnter: function(to, from, next) {
            //     // if (!localStorage.roles.indexOf('Mentor') === -1) {
            //     //     next({ path: '/' });
            //     // } else {
            //     //     next();
            //     // }
            // }
        },
        {
            name: 'mentorProfileEditor',
            path: '/profile-editor',
            component: MentorProfileEditor,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('Mentor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'weeklyUpdates',
            path: '/weekly-updates',
            component: WeeklyUpdates
        },
        {
            name: 'finalProject',
            path: '/final-project',
            component: FinalProject
        },

        {
            name: 'course',
            path: '/course/:termId/:courseId/:instanceId',
            component: Course
        }, {
            name: 'courseAdmin',
            path: '/course-admin/:courseId/:instanceId',
            component: CourseAdmin,
            beforeEnter: function(to, from, next) {
                if (!localStorage.roles.includes('OnlineDirector') &&
                    !localStorage.roles.includes('Faculty') &&
                    !localStorage.roles.includes('Supervisor') &&
                    !localStorage.roles.includes('CourseAdmin') &&
                    !localStorage.roles.includes('LessonAuditor')
                ) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        }, {
            name: 'groupStatistics',
            path: '/group-statistics/:groupId/:groupLabel/:term',
            component: GroupStatistics,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('CourseAdmin') === -1 
                    && localStorage.roles.indexOf('OnlineDirector') === -1 
                    && localStorage.roles.indexOf('Faculty') === -1
                    && localStorage.roles.indexOf('Mentor') === -1
                    && localStorage.roles.indexOf('Supervisor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'handins',
            path: '/handins/:exerciseId',
            component: HandIns,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('CourseAdmin') === -1 && localStorage.roles.indexOf('OnlineDirector') === -1 && localStorage.roles.indexOf('Faculty') === -1 && localStorage.roles.indexOf('Supervisor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'videoPlayer',
            path: '/videos/:courseId/:instanceId/:videoId',
            component: VideoPlayer
        },
        {
            name: 'videoChapters',
            path: '/video-chapters/:courseId/:instanceId/:videoId',
            component: VideoAdmin,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('CourseAdmin') === -1 &&
                    localStorage.roles.indexOf('OnlineDirector') === -1 &&
                    localStorage.roles.indexOf('Faculty') === -1 &&
                    localStorage.roles.indexOf('Supervisor') === -1 &&
                    localStorage.roles.indexOf('LessonAuditor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'introVideos',
            path: '/intro-videos',
            component: IntroVideos,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('Supervisor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        },
        {
            name: 'feedback',
            path: '/feedback',
            component: Feedback,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('Supervisor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        }, {
            name: 'discussion',
            path: '/discussion/:forumId',
            component: Discussion
        }, {
            name: 'thread',
            path: '/thread/:forumId/:topicId/:postId?',
            component: Thread
        }, {
            name: 'settings',
            path: '/settings',
            component: Settings
        },
        {
            name: 'inbox',
            path: '/inbox',
            component: Inbox
        },
        {
            name: 'calendar',
            path: '/calendar',
            component: Calendar
        }, {
            name: 'assignments',
            path: '/assignments',
            component: Assignments
        },
        {
            name: 'resources',
            path: '/resources',
            component: Resources
        },
        {
            name: 'invoices',
            path: '/invoices',
            component: Invoices
        },
        {
            name: 'forum',
            path: '/old-forum',
            component: Forum
        },
        {
            name: 'posts-by-user',
            path: '/forum/user',
            component: PostsByUser
        }, {
            name: 'support',
            path: '/support',
            component: Support
        }, {
            name: 'help',
            path: '/help',
            component: Help
        },
        {
            name: 'help-page',
            path: '/help/:slug',
            component: HelpPage
        },
        {
            name: 'reset-password',
            path: '/reset-password',
            component: ResetPassword
        },
        {
            name: 'software-installation',
            path: '/software-installation',
            component: SoftwareInstallation
        },
        {
            name: 'Software Requests',
            path: '/software-requests',
            component: SoftwareRequests
        },
        {
            name: 'software-keys',
            path: '/software-keys',
            component: SoftwareKeys
        },
        {
            name: 'maintenance',
            path: '/maintenance',
            component: Maintenance
        },
        {
            name: 'galleries',
            path: '/galleries',
            component: GalleryListViewer
        },
        {
            name: 'gallery',
            path: '/galleries/:galleryId',
            component: GalleryViewer
        },
        {
            name: 'new-gallery',
            path: '/new-gallery',
            component: GalleryEditor
        },
        {
            name: 'edit-gallery',
            path: '/edit-gallery/:galleryId',
            component: GalleryEditor,
            props: (route) => ({ id: route.params.galleryId })
        },
        {
            name: 'journey',
            path: '/journey',
            component: Journey,
        },
        {
            name: 'KB Home',
            path: '/kb',
            component: KbHome
        },
        {
            name: 'KB Search',
            path: '/kb-search',
            component: KbSearch
        },
        {
            name: 'KB Article',
            path: '/kb-article/:articleId',
            component: KbArticle
        },
        {
            name: 'KB Article Editor',
            path: '/kb-article-editor/:articleId?',
            component: KbArticleEditor
        },
        {
            name: 'KB Category',
            path: '/kb/:categoryName',
            component: KbCategory
        },
        {
            name: 'forum-home',
            path: '/forum',
            component: ForumHome,
        },
        {
            name: 'forum-categories',
            path: '/forum/categories',
            component: ForumHome,
            props: {
                threadSubset: 'categories',
            },
        },
        {
            name: 'forum-latest',
            path: '/forum/latest',
            component: ForumHome,
            props: {
                threadSubset: 'latest',
            },
        },
        {
            name: 'forum-top',
            path: '/forum/top',
            component: ForumHome,
            props: {
                threadSubset: 'top',
            },
        },
        {
            name: 'forum-top-week',
            path: '/forum/top/weekly',
            component: ForumHome,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'week',
            },
        },
        {
            name: 'forum-top-month',
            path: '/forum/top/monthly',
            component: ForumHome,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'month',
            },
        },
        {
            name: 'forum-top-semester',
            path: '/forum/top/semesterly',
            component: ForumHome,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'semester',
            },
        },
        {
            name: 'forum-category',
            path: '/forum/categories/:categorySlug',
            component: ForumCategory,
        },
        {
            name: 'forum-category-latest',
            path: '/forum/categories/:categorySlug/latest',
            component: ForumCategory,
            props: {
                threadSubset: 'latest',
            },
        },
        {
            name: 'forum-category-top',
            path: '/forum/categories/:categorySlug/top',
            component: ForumCategory,
            props: {
                threadSubset: 'top',
            },
        },
        {
            name: 'forum-category-top-week',
            path: '/forum/categories/:categorySlug/top/weekly',
            component: ForumCategory,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'week',
            },
        },
        {
            name: 'forum-category-top-month',
            path: '/forum/categories/:categorySlug/top/monthly',
            component: ForumCategory,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'month',
            },
        },
        {
            name: 'forum-category-top-semester',
            path: '/forum/categories/:categorySlug/top/semesterly',
            component: ForumCategory,
            props: {
                threadSubset: 'top',
                threadSubsetPeriod: 'semester',
            },
        },
        {
            name: 'new-forum-thread',
            path: '/forum/threads/new',
            component: NewForumThread,
        },
        {
            name: 'forum-thread',
            path: '/forum/threads/:threadId/:threadTitlePreview?',
            component: ForumThread,
        },
        {
            name: 'forum-post',
            path: '/forum/threads/:threadId/:threadTitlePreview/:postId',
            component: ForumThread,
        },
        {
            name: 'forum-search',
            path: '/forum/search',
            component: ForumSearch,
        },
        {
            name: 'forum-user',
            path: '/forum/users/:userId',
            component: ForumUser,
        },

        {
            name: 'student',
            path: '/student/:studentId',
            component: Student,
            beforeEnter: function(to, from, next) {
                if (
                    !localStorage.roles.includes('Faculty') &&
                    !localStorage.roles.includes('OnlineDirector') &&
                    !localStorage.roles.includes('Supervisor') &&
                    !localStorage.roles.includes('Mentor') &&
                    !localStorage.roles.includes('CourseAdmin') &&
                    !localStorage.roles.includes('OnlineReelReviewer') &&
                    !localStorage.roles.includes('CampusDirector')
                ) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        }, {
            name: 'assignment',
            path: '/assignment/:assignmentId',
            component: Assignment,
            beforeEnter: function(to, from, next) {
                if (localStorage.roles.indexOf('Faculty') === -1 && localStorage.roles.indexOf('Supervisor') === -1) {
                    next({ path: '/' });
                } else {
                    next();
                }
            }
        }
    ],

});


router.beforeEach(async (to, from, next) => {

    if (to && to.name) {
        document.title = 'Think Tank | ' + to.name.charAt(0).toUpperCase() + to.name.slice(1);
    } else {
        document.title = 'Think Tank';
    }


    // ?cache=portalsettings
    let settings = await axios.get(window.apiUrl + '/portal-settings');
    if (!settings.data.settings) {
        settings = await axios.get(window.apiUrl + '/portal-settings'); // fall back to uncached
    }
    if (settings.data.settings.length > 0) {

        store.dispatch('populate', { type: 'settings', data: settings.data.settings });
        let maintenanceMode = settings.data.settings.find((s) => { return s.name === 'maintenanceMode'; }).value;

        if (maintenanceMode === true) {
            if (to.name === 'maintenance') {
                return next();
            } else {
                return next({ path: '/maintenance' });
            }
        } else {
            if (to.name === 'maintenance') {
                return next({ path: '/' });
            }
        }
    }

    if (localStorage.token) {
        var decoded = jwtDecode(localStorage.token);
        var exp = decoded.exp;
        var now = new Date().getTime() / 1000;

        if (localStorage.roles.includes('LiteStudent')) {
            const allowedPaths = ['campus-dashboard', 'kb', 'kb-article', 'mentor-selector', 'mentor-profile', 'settings']
            const toPath = to.path.split('/')[1];
            if (!allowedPaths.includes(toPath)) {
                return next({ path: '/campus-dashboard' });
            }
        }

        if (localStorage.roles.includes('Student') && !localStorage.roles.includes('CampusStudent') && localStorage.transitioned != 'true' && !localStorage.terms) {
            toastr.error('Your Foundation term has not yet started.');
            clearLocalStorage();
            store.dispatch('toggle', { type: 'loading', boolean: false });
            window.setTimeout(function() {
                history.go(0)
            }, 1000);
        }

        if (exp < now) {

            toastr.error('Login expired. Please log in again.');
            clearLocalStorage();
            store.dispatch('toggle', { type: 'loading', boolean: false });
            window.setTimeout(function() {
                history.go(0)
            }, 1000);

        } else {
            next();
        }

    } else {
        if (to.name === 'login' || to.name === 'reset-password' || to.name === 'activate') {
            next();
        } else {
            toastr.error('Login expired. Please log in again.');
            clearLocalStorage();
            store.dispatch('toggle', { type: 'loading', boolean: false });
            next({ path: '/' })
            window.setTimeout(function() {
                history.go(0)
            }, 1000);
        }
    }


    // axios.get('//freegeoip.net/json/').then(function(response) {
    //     let ip = response.data.ip;

    //     // james home, matt home, TT office
    //     let allowed = ['69.172.188.75', ,'184.70.129.110', '2001:569:7a38:1300:7043:1bbe:88e2:c54a','184.71.179.2'];
    //     if (!localStorage.getItem('token') && to.name !=='reset-password' && to.name !== 'activate') {

    //         next({ path: '/' });
    //     } else {
    //         if (allowed.indexOf(ip) === -1) {
    //             next({ path: '/maintenance' });
    //         } else {
    //             next();
    //         }
    //     }
    //    });

});


router.beforeEach((to, from, next) => {

    function allowScroll() {
        if (to.name === 'forum-thread' && to.path === from.path) {
            return false;
        }
        if (to.name === 'galleries') {
            return false;
        }
        return true;
    }
    if (allowScroll()) {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }
    next();
});


axios.interceptors.request.use(function(config) {

    config.meta = config.meta || {};
    config.meta.requestStartedAt = new Date().getTime();

    if (localStorage.token) {
        var decoded = jwtDecode(localStorage.token);
        var now = new Date().getTime() / 1000;

        if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
            toastr.error('Login expired. Please log in again.');
            clearLocalStorage();
            store.dispatch('toggle', { type: 'loading', boolean: false });
            window.setTimeout(function() {
                router.push('/');
                history.go(0)
            }, 1000);
        }

    }
    return config;
}, function(error) {
    // Do something with request error
    return Promise.reject(error);
});


axios.interceptors.response.use(async function(response) {
        if (window.location.hostname === 'portal.tttc.ca') {
            const timer = new Date().getTime() - parseInt(response.config.meta.requestStartedAt);

            if (timer > 1500) {   
                try {
                    const transaction = Sentry.startTransaction({
                        op: 'api.request',
                        name: response.config.url,
                    });
                    setTimeout(() => {
                        transaction.finish();
                    }, timer);
                } catch(e) {

                }
            }
        }
        return response;

    },
    function(error) {
        if (error.message.includes('status code 401') && !error.message.includes('rocket')) {

            // var decoded = jwtDecode(localStorage.token);
            // var now = new Date().getTime() / 1000;

            // if (typeof decoded.exp !== 'undefined' && decoded.exp > now) {
            //     toastr.error("You are not authorized to do this");
            // }

        }

        // if(error.message.includes('Request failed with status code 401') && !error.message.includes('rocket chat')) {
        //     toastr.error('Login expired. Please log in again.');
        //     clearLocalStorage();
        //     store.dispatch('toggle',{type:'loading', boolean: false});
        //     window.setTimeout(function() {
        //         router.push('/');
        //         history.go(0)
        //     },1000);
        // }
        return Promise.reject(error);
    });


// axios.interceptors.response.use(function (response) {

//     // if (localStorage.token) {
//     //     var decoded = jwtDecode(localStorage.token);
//     //     var exp = decoded.exp;
//     //     var now = (new Date).getTime();
//     //     now = parseInt(now / 1000); // ms to s

//     //     if (exp < now) {
//     //         toastr.error('Login expired. Please log in again.');
//     //         clearLocalStorage();
//     //         store.dispatch('toggle',{type:'loading', boolean: false});
//     //         window.setTimeout(function() {
//     //             router.push('/');
//     //             window.location.reload();
//     //         },3000)
//     //     }
//     // }

//     if (response.status === 503) {
//        //  toastr.error('Currently in maintenance mode. Please try back later');
//        //  clearLocalStorage();
//        // // store.dispatch('toggle',{type:'loading', boolean: false});
//        //  router.push('/');
//     }

//     return response;

//   }, function (error) {
//     console.log(error);
//     if (error.message.indexOf('Request failed with status code 401') > -1) {
//         // clearLocalStorage();
//         // store.dispatch('toggle',{type:'loading', boolean: false});
//         // toastr.error('Login expired. Please log in again.');

//         // window.setTimeout(function() {
//         //     router.push('/');
//         //     window.location.reload();
//         // },3000)

//     }
//     return Promise.reject(error);
//   })


export default router;



// WEBPACK FOOTER //
// ./src/router.js